// removed by extract-text-webpack-plugin
module.exports = {"SubmitButton":"Feedback__SubmitButton__1XVhz","Feedback":"Feedback__Feedback__2FYy8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Feedback/Feedback.css
// module id = 587
// module chunks = 0